import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface SetupState {
  isCreatingPersona: boolean;
  isUploadingSegmentation: boolean;
  attachModalOpen: boolean;
}

export const initialState: SetupState = {
  isCreatingPersona: false,
  isUploadingSegmentation: false,
  attachModalOpen: false,
};

const setupSlice = createSlice({
  name: "setupSlice",
  initialState,
  reducers: {
    setCreatingPersona: (state, action: PayloadAction<boolean>) => {
      state.isCreatingPersona = action.payload;
    },
    setUploadingSegmentation: (state, action: PayloadAction<boolean>) => {
      state.isUploadingSegmentation = action.payload;
    },
    setAttachModalOpen: (state, action: PayloadAction<boolean>) => {
      state.attachModalOpen = action.payload;
    },
    resetSetup: () => initialState,
  },
});

export const { resetSetup, setAttachModalOpen, setCreatingPersona, setUploadingSegmentation } =
  setupSlice.actions;
export default setupSlice.reducer;
